module.exports = __webpack_public_path__ + "static/img-testimonials-7f6851ccf94ec813c5ee47e6447a6fa6.png";